import { render } from "./App.vue?vue&type=template&id=b7a5bf0e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b7a5bf0e&lang=less"

import exportComponent from "/home/workspace/cjg-consumer-9351/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__